import { NavigateFunction } from 'react-router-dom';
import { DataManagementConfig } from '@shared/components/data-management';
import { SurveyTemplateDTO, CreateSurveyTemplateDTO } from '../dtos';
import { createSurveyTemplatesDataManagementHooks } from '../hooks/useSurveyTemplatesForDataManagement';
import { AddSurveyTemplateDialog } from '../components/AddSurveyTemplateDialog';

export const createSurveyTemplatesConfig = (
  tenantId: string,
  navigate: NavigateFunction
): DataManagementConfig<SurveyTemplateDTO, CreateSurveyTemplateDTO, CreateSurveyTemplateDTO> => {
  const {
    useSurveyTemplatesQuery,
    useCreateSurveyTemplateWrapper,
    useDeleteSurveyTemplateWrapper,
  } = createSurveyTemplatesDataManagementHooks(tenantId);

  return {
    hooks: {
      useQuery: useSurveyTemplatesQuery,
      useCreate: useCreateSurveyTemplateWrapper,
      useDelete: useDeleteSurveyTemplateWrapper,
    },

    table: {
      title: 'Survey Templates',
      columns: [
        { key: 'title', label: 'Name' },
        { key: 'description', label: 'Description', render: (value) => value || null },
        {
          key: 'createdAt',
          label: 'Created',
          render: (value) => (value ? new Date(value).toLocaleDateString() : null),
        },
      ],
      emptyMessage: 'No survey templates found',
      errorMessage: 'Failed to load survey templates. Please try refreshing the page.',
    },

    actions: {
      create: {
        label: 'Create Template',
        dialog: AddSurveyTemplateDialog,
      },
      delete: {
        label: 'Delete',
        confirmTitle: 'Delete Template',
        confirmMessage: (template) => `Are you sure you want to delete "${template.title}"?`,
      },
    },

    features: {
      search: true,
      pagination: true,
      onRowClick: (template) => {
        navigate(`/app/manage/universities/${tenantId}/survey-templates/${template.id}/builder`);
      },
    },
  };
};
